export const FONT_FAMILY = "'Lato', sans-serif";
